import {PropsWithChildren, forwardRef} from 'react';
import {DetailedProps} from '../../../utils/render-utils';
import {join} from '../../../utils/join';
import styles from './styles.module.less';

export type TableHeaderColumnProps = PropsWithChildren<
	{
		className?: string;
	} & DetailedProps<HTMLDivElement>
>;

export const TableHeaderColumn = forwardRef<HTMLDivElement, TableHeaderColumnProps>(
	({className, ...divProps}, ref) => (
		<div
			className={join(styles.tableHeaderColumn, className)}
			ref={ref}
			{...divProps}
		/>
	)
);
